/**
 * Central HTTP client. Single axios instance with a normalized error shape so
 * components never talk to axios directly and error handling is consistent.
 */
import axios from "axios";

import { ENV } from "@/config/env";
import { createLogger } from "@/lib/logger";

const log = createLogger("api");

export const apiClient = axios.create({
  baseURL: ENV.apiBase,
  timeout: 15000,
  withCredentials: true, // send HttpOnly session cookie on every request
  headers: { "Content-Type": "application/json" },
});

export class ApiError extends Error {
  constructor({ code, message, status, details }) {
    super(message);
    this.name = "ApiError";
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const body = error.response?.data?.error;
    const normalized = new ApiError({
      code: body?.code || "network_error",
      message: body?.message || error.message || "Request failed",
      status,
      details: body?.details,
    });
    log.error(`${normalized.code} (${status ?? "n/a"}): ${normalized.message}`);
    return Promise.reject(normalized);
  },
);
